import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type ChangeRoleRows = {
  label: string;
  id: vp.ChangeUserRoleId;
  preset: keyof vp.TextFieldPresets | undefined;
  placeholder: string;
  getSelectOptions: () => { [key: string]: string };
};
const useBuildUserRoleChangeRows = (): ChangeRoleRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.ChangeUserRole' });
  return [
    {
      label: t('roleLabel'),
      id: vp.ChangeUserRoleId.Role,
      preset: 'text',
      placeholder: '',
      getSelectOptions: () => vp.PARTNER_USER_ROLE_OPTIONS,
    },
  ];
};
export default useBuildUserRoleChangeRows;
